import React, { useEffect, useState } from "react";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { Button, Form, Input, Select, Row, Col, message,Space } from "antd";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  getStorage,
} from "firebase/storage";
import { getAuth } from "firebase/auth";
import { FolderOpenOutlined } from "@ant-design/icons";

import {
  validateName,
  validateCharacteristics,
  validatePrice,
} from "./validations";
import { getRecords } from "../../utils";
import { Create } from "../Providers/Create";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

export const AddProduct = ({ handleOk, handleCancel }) => {
  const querydb = getFirestore();
  const auth = getAuth();
  const user = auth.currentUser?.email;

  const { TextArea } = Input;

  const [productcategory, setProductcategory] = useState();
  const [brand, setBrand] = useState();
  const [providers,setProviders] = useState([]);
  const [isAddOpen,setIsAddOpen] = useState(false);

  useEffect(() => {
    getRecords(querydb,"productcategory",setProductcategory);
    getRecords(querydb,"brand",setBrand);
    getRecords(querydb,"providers",setProviders);
    // eslint-disable-next-line
  }, [querydb]);

  const updateProviders = () => {
    getRecords(querydb,"providers",setProviders);
  }

  const [form] = Form.useForm();

  const [fileImage, setFileImage] = useState("");
  const [fileError, setFileError] = useState("");

  // progress
  const [percent, setPercent] = useState(0);
  const [nameFile, setNameFile] = useState("");
  // Handle file upload event and update state
  function handleChange(event) {
    let file = event.target.files[0];

    if (
      !(file.type.startsWith("image/jpeg") || file.type.startsWith("image/png"))
    ) {
      setFileError("Solamente se permiten extensiones .jpg, .jpeg y .png");
    } else {
      const storage = getStorage();

      const storageRef = ref(storage, `${file.name}`);
      setNameFile(`${file.name}`);

      const uploadTask = uploadBytesResumable(storageRef, file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          // update progress
          setPercent(percent);
        },
        (err) => console.log(err),
        () => {
          // download url
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            setFileImage({ fileImage: url });
          });
        }
      );
    }
  }

  const onFinish = (values) => {
    const ordersCollection = collection(querydb, "products");

    const sizeColors = values.sizeColor;

    sizeColors.map((ele, i) => {
      return addDoc(ordersCollection, {
        brand: values.brand,
        buyPrice: values.buyPrice,
        category: values.category,
        characteristics: values.characteristics,
        model: values.model,
        productName: values.productName,
        provider: values.provider,
        sellPrice: values.sellPrice,
        size: ele.size,
        color: ele.color,
        quantity: ele.quantity,
        sku: values.sku,
        ...fileImage,
        seller: user,
      });
    });
    message.success(`Datos enviados correctamente`);
    form.resetFields();
    handleOk();
  };

  return (
    <Form
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      initialValues={""}
    >
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="productName"
            label="Nombre del Producto"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
              {
                validator: validateName,
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="sku"
            label="SKU"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="brand"
            label="Marca"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
            ]}
          >
            <Select placeholder="Seleccione una opcion">
              {brand &&
                brand?.map((storage, i) => {
                  return (
                    <Option
                      key={i}
                      value={storage.name}
                      label={storage.name}
                      name={storage.name}
                    >
                      {storage.name}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="category"
            label="Categoria"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
            ]}
          >
            <Select placeholder="Seleccione una opcion">
              {productcategory &&
                productcategory?.map((storage, i) => {
                  return (
                    <Option
                      key={i}
                      value={storage.name}
                      label={storage.name}
                      name={storage.name}
                    >
                      {storage.name}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="model"
            label="Modelo"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row
        style={{
          marginTop: 10,
        }}
      >
        <Col span={12} offset={6}>
          <Form.List name="sizeColor">
            {(fields, { add, remove }) => (
              <>
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    size="large"
                  >
                    Añadir Talla
                  </Button>
                </Form.Item>
                {fields.map(({ key, name, ...restField }) => (
                  <Space
                    key={key}
                    style={{
                      display: "flex",
                      marginBottom: 8,
                      justifyContent: "center",
                    }}
                    align="baseline"
                  >
                    <Form.Item
                      {...restField}
                      name={[name, "size"]}
                      rules={[
                        {
                          required: true,
                          message: "Campo requerido",
                        },
                      ]}
                    >
                      <Input placeholder="Talla" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, "color"]}
                      rules={[
                        {
                          required: true,
                          message: "Campo requerido",
                        },
                      ]}
                    >
                      <Input placeholder="Color" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, "quantity"]}
                      rules={[
                        {
                          required: true,
                          message: "Campo requerido",
                        },
                      ]}
                    >
                      <Input placeholder="Cantidad" />
                    </Form.Item>

                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </Space>
                ))}
              </>
            )}
          </Form.List>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="buyPrice"
            label="Precio de compra"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
              {
                validator: validatePrice,
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="sellPrice"
            label="Precio de venta"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
              {
                validator: validatePrice,
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}> 
          <Form.Item
            name="provider"
            label="Proveedor"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
            ]}
          > 
            <Space>
              <Button type="primary" onClick={() => setIsAddOpen(true)}><PlusOutlined/></Button>
              <Create isModalOpen={isAddOpen} setIsModalOpen={setIsAddOpen} update={updateProviders}/>
              <Select placeholder="Seleccione una opcion">
                {providers &&
                  providers?.map((storage, i) => {
                    return (
                      <Option
                        key={i}
                        value={storage.name}
                        label={storage.name}
                        name={storage.name}
                      >
                        {storage.name}
                      </Option>
                    );
                  })}
              </Select>
            </Space>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="characteristics"
            label="Características"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
              {
                validator: validateCharacteristics,
              },
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <h4>Ingrese la imagen del producto</h4>
          <label className={nameFile ? "filelabelcheck" : "filelabel"}>
            <FolderOpenOutlined />
            <br />
            <span className="title">Elegir archivo</span>

            <input
              id="FileInput"
              type="file"
              onChange={handleChange}
              accept="/image/*"
            />
            {!fileError.length ? null : <p>{fileError}</p>}
            <p>{nameFile}</p>
            <p>{percent}% cargado</p>
          </label>
        </Col>
      </Row>

      <Form.Item className="footer-btn-modal">
        <Button size="large" onClick={() => handleCancel()}>
          Cancelar
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          size="large"
          className="button-right"
        >
          Guardar
        </Button>
      </Form.Item>
    </Form>
  );
};
